import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface CheckboxProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onChange' | 'id'> {
    id: string;
    label: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
    count?: number;
}

export function Checkbox({  label, checked, onChange, count, className, ...props }: CheckboxProps) {
    return (
        <div
            className={cn("flex items-center space-x-3 py-1.5 group cursor-pointer", className)}
            onClick={(e) => {
                e.preventDefault();
               onChange(!checked);
            }}
        >
            <button
                type="button"
                role="checkbox"
                aria-checked={checked}
                className={cn(
                    "peer h-4.5 w-4.5 shrink-0 rounded border border-zinc-700 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 transition-all",
                    checked ? "bg-brand-gold border-brand-gold text-black scale-105" : "bg-transparent text-transparent group-hover:border-zinc-500"
                )}
                {...props}
            >
                <Check className="h-3.5 w-3.5" />
            </button>
            <span
                className={cn(
                    "flex-1 text-sm font-medium leading-tight peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer select-none transition-colors truncate",
                    checked ? "text-brand-gold" : "text-zinc-400 group-hover:text-white"
                )}
            >
                {label}
            </span>
            {count !== undefined && (
                <span className="text-[10px] text-zinc-600 font-bold opacity-80 shrink-0">({count})</span>
            )}
        </div>
    );
}
